/**
 * @fileOverview Footer collapse class
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Local:scroll-to-top
 */

import scrollToTop from '../../00-utilities/scroll-to-top';

/**
 * Init scroll to header
 */
export default function initScrollToHeader() {
  // Listen click on button scroll to top
  const btnScrollTop = document.querySelector( '.ac-footer__scroll-top' );

  if ( btnScrollTop ) {
    btnScrollTop.addEventListener( 'click', ( e ) => {
      e.preventDefault();
      scrollToTop();
    });
  }
}
